<template>
  <b-tabs v-model="tabIndex" card active-nav-item-class="font-weight-bold text-uppercase text-black">
    <b-tab :title-link-class="linkClass(0)" lazy>
      <template #title>
        <i class="fa fa-list-alt font-size-20"></i> Informes
      </template>
      <a-skeleton active :loading="tabInformes"/>
      <report v-show="!tabInformes" v-on:general='general'></report>
    </b-tab>
    <b-tab :title-link-class="linkClass(1)" lazy>
      <template #title>
        <i class="fa fa-bar-chart font-size-20"></i> Gráficos
      </template>
      <a-skeleton active :loading="tabGraficos"/>
      <graphic v-show="!tabGraficos" v-on:graphic='graphic'></graphic>
    </b-tab>
  </b-tabs>
</template>
<script>
  import Report from '../../components/report/Report.vue'
  import Graphic from '../../components/report/Graphic.vue'

  export default {
    data() {
      return {
        tabInformes: true,
        tabGraficos: true,
        tabIndex: 0,
      }
    },

    components: {
      'report': Report,
      'graphic': Graphic,
    },

    watch: {
      tabIndex(val) {
        if (val != 0 || val != 1) {
          this.tabInformes = true
          this.tabGraficos = true
        }
      }
    },

    methods: {
      general(e) {
        this.tabInformes = e
      },

      graphic(e) {
        this.tabGraficos = e
      },

      linkClass(idx) {
        if (this.tabIndex === idx) {
          return ['text-black']
        } else {
          return ['text-success font-weight-bold']
        }
      },
    }
  }
</script>